<template>
  <div class="recruit-1 content">
    <div class="banner-sub">
      <img :src="topBg.indexTopImg" alt="">
    </div>
    <div class="wrap">
      <div class="title">
        <h2>热招岗位</h2>
        <span></span>
      </div>
      <div class="j-box">
        <div class="j-seach">
          <div class="select">
            <select v-model="seachType">
              <option v-for="item in seachTypeList" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
          <input class="input" placeholder="请输入" v-model="seachName" />
          <div class="seach-input" @click="initJoin()">
            <span>搜索</span>
          </div>
        </div>
        <div class="j-table">
          <div class="item" v-for="(item, idx) in joinList" :key="idx" @click="gotoWorkDetail(item.id)">
            <div class="left">
              <div class="left-01">
                <h2>{{item.position}}</h2><span>{{ item.salary }}</span>
              </div>
              <div class="left-02">
                <span>{{ item.workTime }}年经验</span>
                <span>{{ item.education }}</span>
                <span>招{{ item.amount }}人</span>
                <span>{{ item.sysDeptName }}</span>
              </div>
            </div>
            <div class="right">
              <span class="right-01">{{ item.workAddr }}</span>
              <span class="right-02">{{ item.publicTime }}</span>
            </div>
          </div>
        </div>
        <div class="page">
          <pagination :pagination="pagination" :callback="getTableData" :options="paginationOptions"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'vue-bootstrap-pagination'
import {ApiWebRecruitImg, ApiWebRecruitInfo, ApiWebRecruitJoin} from '../api/recruit'
export default {
  name: 'joinUs',
  data () {
    return {
      seachTypeList: [
        { 'id': -1, 'name': '全部' },
        { 'id': 1, 'name': '社会招聘' },
        { 'id': 2, 'name': '校园招聘' }
      ],
      seachType: -1,
      seachName: '',
      pagination: {
        per_page: 10, // 每页数
        current_page: 1, // 当前页
        last_page: 35 // 总页数
      },
      paginationOptions: {
        offset: 4,
        previousText: '<',
        nextText: '>',
        alwaysShowPrevNext: true
      },
      // 招聘列表
      joinList: [],
      // 背景图片
      topBg: {
        indexTopIng: null,
        recruitJoinTopImg: null,
        joinDetailTopImg: null
      },
      recruitInfo: {
        img: null,
        title: null,
        content: null
      }
    }
  },
  components: {
    pagination
  },
  mounted () {
    this.initJoin()
    this.topRecruit()
    this.topbackground()
  },
  created () {
  },
  methods: {
    getTableData () {},
    /**
     * 人才招聘顶部背景图
     */
    topbackground () {
      ApiWebRecruitImg().then(({data}) => {
        if (data && data.status === 0) {
          this.topBg = data.data
        }
      })
    },
    /**
     * 人才招聘顶部模块
     */
    topRecruit () {
      ApiWebRecruitInfo().then(({data}) => {
        if (data && data.status === 0) {
          this.recruitInfo = data.data
        }
      })
    },
    /**
     * 跳转到职位详情页
     * id为职位id
     */
    gotoWorkDetail(id) {
      this.$store.commit('job/setJobId', id)
      this.$router.push({ name: 'recruitJoinDetail', params: { jobId: id } })
    },
    /**
     * 加入我们列表
     */
    initJoin () {
      let params = {
        'type': this.seachType === -1 ? null : this.seachType,
        'name': this.seachName,
        'curr': this.pagination.current_page,
        'size': this.pagination.per_page
      }
      ApiWebRecruitJoin(params).then(({data}) => {
        if (data && data.status === 0) {
          let table = data.data
          this.pagination.current_page = table.curr
          this.pagination.per_page = table.size
          this.pagination.last_page = table.page
          this.joinList = table.list
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../assets/style/index.less';
</style>



// WEBPACK FOOTER //
// src/components/recruit-join.vue